import { platformApi } from '../../../../api/endpoints/platform';
import { UserActionsMenu } from '../../../../components/shared/UserActionsMenu';
import type { TenantUserListItemLocal } from '../../../../api/types/TenantLocal';

interface Props {
    user: TenantUserListItemLocal;
    /** tenantId del DRILL-DOWN (param de ruta), NO el del user logueado. */
    tenantId: string;
}

/**
 * Menú "⋮" de acciones por fila de usuario en el módulo Platform (drill-down del tenant). Delega en
 * `UserActionsMenu` (compartido con el tenant propio y retailer) inyectando el binding
 * `platformApi.*TenantUser` sobre el `tenantId` del path, los permisos `tenant.user.*` y el scope
 * TENANT/tenantId (el platform admin lo cubre por rank). El backend re-enforza.
 */
export function PlatformTenantUserRowActions({ user, tenantId }: Props) {
    const sub = user.cognitoSub;
    return (
        <UserActionsMenu
            user={user}
            tenantId={tenantId}
            gateScope="TENANT"
            gateScopeRef={tenantId}
            api={{
                getDetail: () => platformApi.getTenantUser(tenantId, sub),
                update: (body) => platformApi.updateTenantUser(tenantId, sub, body),
                disable: () => platformApi.disableTenantUser(tenantId, sub),
                enable: () => platformApi.enableTenantUser(tenantId, sub),
                delete: () => platformApi.deleteTenantUser(tenantId, sub),
                resetPassword: () => platformApi.resetPasswordTenantUser(tenantId, sub),
                resetMfa: () => platformApi.resetMfaTenantUser(tenantId, sub),
                resendInvitation: () => platformApi.resendInvitationTenantUser(tenantId, sub),
            }}
            perms={{
                update: 'tenant.user.update',
                passwordReset: 'tenant.user.password.reset',
                mfaReset: 'tenant.user.mfa.reset',
                status: 'tenant.user.status',
                delete: 'tenant.user.delete',
            }}
            detailQueryKey={['platform', 'tenants', tenantId, 'users', sub, 'detail']}
            listQueryKey={['platform', 'tenants', tenantId, 'users']}
        />
    );
}
